export default "__VITE_ASSET__AHXyoig0__"